import { createSlice, current } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { ORDERS_FILTERS_FUNCTIONS } from '@sonifi/wb-guest-request/constants/wbGuestRequestConstants';

const initialState = {
  loadingOrder: LOADING_STATUS.notLoading,
  loadingOrders: LOADING_STATUS.notLoading,
  localFilters: [
    {
      id: 'guestRequestOrdersLocalFilter',
      name: 'Hide failed',
      description: 'Hides orders that have failed to submit',
      enabled: true,
      detail: '',
    },
  ],
  order: null,
  orders: [],
  ordersFiltered: [],
};

const getOrdersFiltered = (orders, localFilters) => {
  let ordersFiltered = [...orders];
  const lfs = JSON.parse(JSON.stringify(localFilters)); // Replace for structuredClone in the future

  for (const localFilter of lfs) {
    let countFiltered = 0;
    if (localFilter.enabled) {
      ordersFiltered = orders.filter((order) => {
        const accept = ORDERS_FILTERS_FUNCTIONS[localFilter.id](order);
        if (!accept) {
          countFiltered++;
        }
        return accept;
      });
    }
    localFilter.detail = countFiltered
      ? `${countFiltered} hidden ${countFiltered > 1 ? 'orders' : 'order'}`
      : '';
  }
  return { ordersFiltered, localFilters: lfs };
};

export const guestRequestOrdersSlice = createSlice({
  name: 'guestRequestOrdersSlice',
  initialState,
  reducers: {
    setLoadingGuestRequestOrder(state, action) {
      state.loadingOrder = action.payload;
    },
    setLoadingGuestRequestOrders(state, action) {
      state.loadingOrders = action.payload;
    },
    setOrder: (state, action) => {
      const { order } = action.payload;
      state.order = order;
    },
    setOrders: (state, action) => {
      const { orders } = action.payload;
      const { localFilters } = current(state);
      state.orders = orders;
      const { ordersFiltered, localFilters: newLocalFilters } =
        getOrdersFiltered(orders, localFilters);
      state.localFilters = newLocalFilters;
      state.ordersFiltered = ordersFiltered;
    },
    updateLocalFilters: (state, action) => {
      const filter = action.payload;
      const { localFilters, orders } = current(state);
      const newLocalFilters = localFilters.map((lf) => {
        if (filter.id === lf.id) {
          return { ...lf, enabled: !lf.enabled };
        } else {
          return lf;
        }
      });
      const filterRes = getOrdersFiltered(orders, newLocalFilters);
      state.localFilters = filterRes.localFilters;
      state.ordersFiltered = filterRes.ordersFiltered;
    },
    cleanGuestRequestOrdersSlice() {
      return initialState;
    },
  },
});

export const {
  cleanGuestRequestOrdersSlice,
  setLoadingGuestRequestOrder,
  setLoadingGuestRequestOrders,
  setOrder,
  setOrders,
  updateLocalFilters,
} = guestRequestOrdersSlice.actions;

export default guestRequestOrdersSlice.reducer;
